import { z } from "zod";

export const addressSchema = z.object({
  zipcode: z.string().optional().nullable(),
  street: z.string().optional().nullable(),
  number: z.string().optional().nullable(),
  neighborhood: z.string().optional().nullable(),
  city_id: z.string().optional().nullable(),
  complement: z.string().optional().nullable(),
  latitude: z.string().optional().nullable(),
  longitude: z.string().optional().nullable(),
  city: z.object({
    acronym: z.string().optional().nullable(),
    display_name: z.string().optional().nullable(),
    id: z.string().optional().nullable(),

  }).optional().nullable()

});

export type AddressValidationSchema = z.infer<typeof addressSchema>;
